import { Platform } from 'react-native'

export function useDynamicSnapPoints() {
  const isIOS = Platform.OS === 'ios'

  const snapPoints = isIOS ? [95] : [100]

  return { snapPoints }
}
